<!-- Pending audit banner message -->
@if (summaryData?.length && auditPending) {
  <div class="audits-error-wrapper">
    <div class="pending-audits-error">
      <span class="material-icons">lock_outlined</span>
      Document editing is locked due to&nbsp;
      <u>Pending Audits</u>
    </div>
  </div>
}
<!-- Edit doc main container (host) -->
<as-split #splitEl>
  <!-- PDF viewer (left side) slider/resize container -->
  <as-split-area [size]="50" [maxSize]="65" [minSize]="35">
    <div class="PDF-main-container">
      @if (activatePdfViewer) {
        <app-extended-pdf-viewer
          #pdfViewer
          (pdfLoadedAndProxyEmitter)="loadComplete($event)"
          (textRenderedEmitter)="populatePdf()"
          (ouputputIdHighlightActive)="detectActiveInputElement($event)"
          [fieldValues]="fieldValues"
          [inputIdHighlightActive]="inputIdHighlightActive"
          [gutterPosition]="gutterPositionValue"
          [disableEditing]="disableEditing"
        ></app-extended-pdf-viewer>
      }
    </div>
  </as-split-area>
  <!-- Edit doc form main container -->
  <as-split-area [size]="50">
    <div class="pdf-edit-right-panel">
      <!-- Tabs -->
      @if (
        !fetchingDocumentName &&
        originalSummaryData?.length > 0 &&
        !fetchingAudits &&
        !fetchingFields &&
        pdfLoadComplete &&
        checkForWizard()
        ) {
        <div class="tabs">
          <div [ngClass]="{ inactive: !currentTabAll }" (click)="handleTabClick('all')">
            <h3>All Fields</h3>
          </div>
          <div [ngClass]="{ inactive: currentTabAll }" (click)="handleTabClick('wizard')">
            <h3>Wizard</h3>
          </div>
        </div>
      }
      <!-- Form fields with expansion panels -->
      @if (currentTabAll) {
        <div class="data-tree-main">
          @if (fetchingFields || !pdfLoadComplete) {
            <app-spinner></app-spinner>
          }
          @if (!summaryData?.length && !fetchingFields) {
            <h3>No data to display</h3>
          }
          @if (fetchingAudits && !fetchingFields) {
            <div class="fetch-audits-loader">
              <h3>Syncing</h3>
              <app-spinner></app-spinner>
            </div>
          }
          <!-- Form with input fields -->
          @if (summaryData?.length > 0 && !fetchingAudits && !fetchingFields && pdfLoadComplete) {
            <div
              id="formAccordion"
              class="accordion"
              >
              <!-- Filtering section -->
              @if (
                originalSummaryData?.length > 0 &&
                !fetchingAudits &&
                !fetchingFields &&
                pdfLoadComplete
                ) {
                <div
                  class="accordion-item"
                  >
                  <h5 id="formFiltersAccordionHeader" class="accordion-header">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#formFiltersAccordionCollapse"
                      aria-expanded="false"
                      aria-controls="formFiltersAccordionCollapse"
                      >
                      FILTER FORM FIELDS
                    </button>
                  </h5>
                  <div
                    id="formFiltersAccordionCollapse"
                    class="accordion-collapse collapse"
                    aria-labelledby="formFiltersAccordionHeader"
                    data-bs-parent="#formAccordion"
                    >
                    <div class="accordion-body">
                      <div class="input-search-wrapper">
                        <div class="search-component">
                          <div class="form-search p-2">
                            <div class="search-container w-100">
                              <input
                                class="c-control"
                                type="search"
                                [(ngModel)]="searchInput"
                                placeholder="Search documents fields"
                                /><!--When searching for fields, fields on scanned document should be filtered also-->
                              </div>
                            </div>
                            @for (filter of filterOptions; track filter; let i = $index) {
                              <div>
                                <input
                                  name="{{ filter.name }}"
                                  type="checkbox"
                                  [(ngModel)]="filterOptions[i].checked"
                                  (change)="checkSelectAll()"
                                  class="checkbox"
                                  />
                                  {{ filter.name }}
                                </div>
                              }
                              <div>
                                <input
                                  name="select all"
                                  type="checkbox"
                                  [(ngModel)]="allSelected"
                                  (change)="toggleAllSelection()"
                                  class="checkbox"
                                  />
                                  (Select all)
                                </div>
                                <div class="buttons">
                                  <button class="reset" (click)="resetSearch()">Clear</button>
                                  <button class="apply" (click)="filterSearch()">Apply</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    <!-- Panels with sections and fields inside sections, expansion header doesn't work separated in child component -->
                    @for (section of summaryData; track section; let i = $index) {
                      <div class="accordion-item">
                        <h5 [id]="'formSection' + i + 'Header'" class="accordion-header">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            [attr.data-bs-target]="'#formSection' + i + 'Collapse'"
                            aria-expanded="false"
                            [attr.aria-controls]="'#formSection' + i + 'Collapse'"
                            >
                            {{ section[0].sectionName }}
                            <span
                              data-toggle="tooltip"
                              data-placement="auto"
                              [title]="'By clicking the title, all fields section will be highlighted'"
                              class="material-icons"
                              >info_outlined</span
                              >
                            </button>
                          </h5>
                          <div
                            [id]="'formSection' + i + 'Collapse'"
                            class="accordion-collapse collapse show"
                            [attr.aria-labelledby]="'formSection' + i + 'Header'"
                            data-bs-parent="#formAccordion"
                            >
                            <div class="accordion-body">
                              <app-edit-doc-form-section-content
                                [formSection]="section"
                                [fieldValues]="fieldValues"
                                [changedFieldKeys]="changesKeys"
                                [disableEditing]="disableEditing"
                                [inputIdHighlightActive]="inputIdHighlightActive"
                                (inputChangedEmitter)="handleFormDataChange()"
                                (onInputClickEmitter)="setActiveInputElement($event)"
                                (rowAddedEmitter)="populatePdf()"
                              ></app-edit-doc-form-section-content>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              <!-- TODO: agreeAndSaveCheck is being evaluated on scroll, keypress, everything! need to make this performant! -->
              @if (!fetchingFields && !fetchingAudits && pdfLoadComplete && summaryData?.length > 0) {
                <div
                  class="agreeAndSave"
                  >
                  <styled-button
                    [styleClass]="'light-green'"
                    [disabled]="agreeAndSaveCheck()"
                    (clickEmitter)="pdfPopulateService.populateFormData(); handleAgreeAndSaveClick()"
                    >
                    Agree and Save
                  </styled-button>
                </div>
              }
            </div>

            @if (!currentTabAll) {
              <div class="wizard-container">
                <app-wizard
                  #wizard
                  [wizardConfig]="wizards[activeWizard]"
                  [boType]="documentInfo.BeneficialOwnerTypeID"
                  (emitWizardFields)="mapWizardFields($event)"
                ></app-wizard>
              </div>
            }
          </as-split-area>
        </as-split>
